import React, { useEffect, useState } from 'react';
import { popupText } from './api';
import { MODELES, modeleOf } from './modeles';

// One pop-up from the database, drawn by its modal of the modeles/ folder. onAction(action) with:
//   done  : main button        later : « Plus tard »
//   close : × / Échap          never : either of them with « Ne plus afficher » ticked
// lang forces a language (admin preview); otherwise the page language.
// contact: state of the « Je souhaite être contacté » email, drawn by the modal (see ImageTexte.jsx)
export default function PopupModal({ popup, open, onAction, loading, lang, zIndex, contact }) {
  const [never, setNever] = useState(false);

  const popupId = popup && popup.id;
  useEffect(() => setNever(false), [popupId]);

  if (!popup) return null;
  const Modele = (MODELES[modeleOf(popup)] || MODELES.image).component;
  const dismiss = (action) => onAction(never ? 'never' : action);
  const text = popupText(popup.contenu, lang);

  // key: a new modal for each pop-up. Reusing the same one, the end of the closing animation of the
  // previous pop-up (reactstrap onClosed) hid the next one as it opened.
  return (
    <Modele
      key={popup.id}
      popup={popup}
      text={text}
      open={open}
      loading={loading}
      zIndex={zIndex}
      contact={contact}
      onDone={() => onAction('done')}
      onLater={() => dismiss('later')}
      onClose={() => dismiss('close')}
      never={never}
      setNever={setNever}
    />
  );
}
